window.addEventListener('DOMContentLoaded', () => {
  // ハンバーガーメニュー
  const btnMenu = document.querySelector('.js__nav-btn'),
        headNav = document.querySelector('#js__nav')

  function hamburger() {
    if (btnMenu.classList.contains("is-open")) {
      btnMenu.classList.remove('is-open')
      btnMenu.querySelector('.btn-menu-text').textContent = 'メニュー'
      headNav.classList.remove('is-active')
      document.body.classList.remove('is-active')
    } else {
      btnMenu.classList.add('is-open')
      btnMenu.querySelector('.btn-menu-text').textContent = '閉じる'
      headNav.classList.add('is-active')
      document.body.classList.add('is-active')
    }
  }
  if (window.innerWidth < 768) {
    btnMenu.addEventListener('click', hamburger)
  }
})
